import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerEditProfileDetailsQueryVariables = Types.Exact<{
  learnerId: Types.Scalars['String']['input'];
}>;


export type LearnerEditProfileDetailsQuery = { user?: { status: Types.UserStatusEnum, emailId?: string | null, id: string, name?: string | null, firstName?: string | null, uniqueId: string, profilePicture?: string | null, orgRole?: { id: string, name: string } | null, manager?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, reportees?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, department?: { id: string, name: string } | null, responsibilities?: Array<{ id: string }> | null } | null };

export type LearnerEditProfileDetailsFragment = { status: Types.UserStatusEnum, emailId?: string | null, id: string, name?: string | null, firstName?: string | null, uniqueId: string, profilePicture?: string | null, orgRole?: { id: string, name: string } | null, manager?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, reportees?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, department?: { id: string, name: string } | null, responsibilities?: Array<{ id: string }> | null };


export type LearnerEditProfileDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LearnerEditProfileDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment LearnerEditProfileDetails on UserType {
  ...User
  status
  emailId
  orgRole {
    id
    name
  }
  manager {
    ...User
  }
  reportees {
    ...User
  }
  cover {
    ...EntityMedia
  }
  department {
    id
    name
  }
  responsibilities {
    id
  }
}
    `;
export const LearnerEditProfileDetailsDocument = /*#__PURE__*/ gql`
    query learnerEditProfileDetails($learnerId: String!) {
  user(filters: {userId: $learnerId}) {
    ...LearnerEditProfileDetails
  }
}
    ${LearnerEditProfileDetailsFragmentDoc}
${UserFragmentDoc}
${EntityMediaFragmentDoc}`;

export function useLearnerEditProfileDetailsQuery(options: Omit<Urql.UseQueryArgs<LearnerEditProfileDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerEditProfileDetailsQuery, LearnerEditProfileDetailsQueryVariables>({ query: LearnerEditProfileDetailsDocument, ...options });
};